import React from 'react';
import { withRouter } from 'react-router-dom';
import Constants, { meetURL } from '../utils/Constants';
import {
    buildInPatientRoomUrl,
    buildQrCodeImageUrl,
    buildRoomQrLabel,
    downloadRoomQrCard,
    getRoomQrCardStyles,
} from '../utils/roomQrCard';

class VendorRoomViewScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showQR: false,
            downloadingKey: '',
            downloadError: '',
            isCopied: false,
        };
    }

    toggleQR = () => {
        this.setState({ showQR: !this.state.showQR, downloadError: '' });
    };

    handleCopyUrl = async (copyText) => {
        try {
            await navigator.clipboard.writeText(copyText);
            this.setState({ isCopied: true });
        } catch (error) {
            console.error('Failed to copy URL:', error);
        }
    };

    handleDownloadCard = async (variant, format = 'png') => {
        const { data } = this.props;
        const inPatientURL = buildInPatientRoomUrl(data, meetURL);
        const roomLabel = buildRoomQrLabel(data);
        const downloadingKey = `${variant}-${format}`;

        this.setState({ downloadingKey, downloadError: '' });
        try {
            await downloadRoomQrCard({
                patientUrl: inPatientURL,
                roomLabel,
                downloadName: data && data.patientRoomId,
                variant,
                format,
            });
        } catch (error) {
            console.error('Error downloading QR card:', error);
            this.setState({ downloadError: 'Unable to download QR card. Please try again.' });
        } finally {
            this.setState({ downloadingKey: '' });
        }
    };

    renderDownloadButton = (variant, format, label) => {
        const { downloadingKey } = this.state;
        const key = `${variant}-${format}`;
        const isBusy = !!downloadingKey;
        const isThis = downloadingKey === key;
        return (
            <button
                className="btn btn-primary btn-sm px-3 py-2"
                disabled={isBusy}
                onClick={() => this.handleDownloadCard(variant, format)}
                type="button"
            >
                <i className="bi bi-download me-1"></i>
                {isThis ? 'Downloading...' : label}
            </button>
        );
    };

    render() {
        const { data } = this.props;
        const inPatientURL = buildInPatientRoomUrl(data, meetURL);
        const roomLabel = buildRoomQrLabel(data);
        const cardStyles = getRoomQrCardStyles('a4');
        const { showQR, downloadError, isCopied } = this.state;

        return (
            <div className="content-part px-5 py-4 list">
                <div className="agent-details">
                    <div className='row'>
                        <div className="col-md-6">
                            <div className='row'>
                                <div className='col-6 text-bold'>
                                    Room Number :
                                </div>
                                <div className='col-6'>
                                    <p>{data && data.patientRoomId}</p>
                                </div>
                                <div className='col-6 text-bold'>
                                    Room Name :
                                </div>
                                <div className='col-6'>
                                    <p>{data && data.patientRoomName}</p>
                                </div>
                                <div className='col-6 text-bold'>
                                    Room code :
                                </div>
                                <div className='col-6'>
                                    <p>{data && data.encryptRoomId}</p>
                                </div>
                                <div className='col-6 text-bold'>
                                    URL :
                                </div>
                                <div className='col-6'>
                                    <p className="m-0">{inPatientURL}</p>
                                    <button
                                        className="script_code_btn mt-2"
                                        type="button"
                                        onClick={() => this.handleCopyUrl(inPatientURL)}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-files" viewBox="0 0 16 16">
                                            <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z" />
                                        </svg>
                                        <p className="m-0">{isCopied ? 'Copied' : 'Copy'}</p>
                                    </button>
                                </div>
                                <div className='col-12'>
                                    <button className="script_code_btn mt-2" onClick={() => this.toggleQR()}>
                                        <p className="m-0">{showQR ? 'Hide QR' : 'Show QR'}</p>
                                    </button>
                                </div>
                                {showQR && (
                                    <div className="col-12 text-center mt-3">
                                        <div
                                            className="d-inline-block"
                                            style={cardStyles.page}
                                        >
                                            <div style={cardStyles.frame} />
                                            <img
                                                src={`${process.env.PUBLIC_URL || ''}/srm_qr_logo.png`}
                                                alt="SRM Logo"
                                                style={cardStyles.logo}
                                            />
                                            <img
                                                src={buildQrCodeImageUrl(inPatientURL, 1294)}
                                                alt="QR Code"
                                                style={cardStyles.qr}
                                            />
                                            <p className="m-0" style={cardStyles.scanText}>
                                                For Nursing Service Scan Here.
                                            </p>
                                            <p className="m-0" style={cardStyles.roomText}>
                                                Room No: {roomLabel}
                                            </p>
                                        </div>
                                        <div className="d-flex justify-content-center gap-2 flex-wrap mt-3">
                                            {this.renderDownloadButton('small', 'png', 'Small PNG')}
                                            {this.renderDownloadButton('small', 'pdf', 'Small PDF')}
                                            {this.renderDownloadButton('a4', 'png', 'A4 PNG')}
                                            {this.renderDownloadButton('a4', 'pdf', 'A4 PDF')}
                                        </div>
                                        {downloadError ? (
                                            <p className="text-danger mt-2 mb-0">{downloadError}</p>
                                        ) : null}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className=" mt-5 me-5 pb-3 d-flex justify-content-start">
                        <button type="button" className="btn input-btn" onClick={() => this.props.history.goBack()} >{Constants.BACK}</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(VendorRoomViewScreen);
